import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import {
  CreateEvent,
  Event,
  EventAttendees,
  Events,
  Home,
  Login,
  Logout,
  MagicLink,
  MagicCode,
  Signup,
  SignupSuccess,
  SignupError,
  Group,
  GroupList,
  GroupCreate,
  User,
  QuickGuides,
  FAQ,
  Support,
  SendMessage,
} from '.';
import Footer from './Footer';
import Nav from './Nav';
import ScrollToTop from './ScrollToTop';
import PrivateRoute from './PrivateRoute';

// Params are placeholders in the URL that begin
// with a colon, like the `:id` param defined in
// the route in this example. A similar convention
// is used for matching dynamic segments in other
// popular web frameworks like Rails and Express.
export default function Router() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Nav />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/magic/link/:code" element={<MagicLink />} />
        <Route exact path="/magic/code" element={<MagicCode />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/logout" element={<Logout />} />
        <Route path="/signup/success" element={<SignupSuccess />} />
        <Route path="/signup/error" element={<SignupError />} />
        <Route path="/signup" element={<Signup />} />
        <Route
          path="/events/create"
          element={
            <PrivateRoute>
              <CreateEvent />
            </PrivateRoute>
          }
        />
        <Route
          path="/events/update/:id"
          element={
            <PrivateRoute>
              <CreateEvent />
            </PrivateRoute>
          }
        />
        <Route
          path="/events/event/:id/attendees"
          element={<EventAttendees />}
        />
        <Route path="/events/event/:id" element={<Event />} />
        <Route
          path="/events"
          element={
            <PrivateRoute path="/events">
              <Events />
            </PrivateRoute>
          }
        />

        <Route path="/quick-guides" element={<QuickGuides />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/support" element={<Support />} />
        <Route
          path="/group/create"
          element={
            <PrivateRoute path="/group/create">
              <GroupCreate />
            </PrivateRoute>
          }
        />
        <Route
          path="/group/:id/*"
          element={
            <PrivateRoute path="/group/:id/*">
              <Group />
            </PrivateRoute>
          }
        />
        <Route
          path="/user/:id/groups"
          element={
            <PrivateRoute path="/user/:id/groups">
              <GroupList />
            </PrivateRoute>
          }
        />
        <Route
          path="/user/:id/*"
          element={
            <PrivateRoute path="/user/:id/*">
              <User />
            </PrivateRoute>
          }
        />
        <Route
          path="/message"
          element={
            <PrivateRoute path="/message">
              <SendMessage />
            </PrivateRoute>
          }
        />
        {/* <Route>
          <Navigate to="/" />
        </Route> */}
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}
